/**
 * xceller. Auth Service
 * API calls for authentication
 */

const API = process.env.REACT_APP_API_URL || '/api';

class AuthService {
  async register(email, password, displayName) {
    const res = await fetch(`${API}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, display_name: displayName }),
    });
    return res.json();
  }

  async login(email, password) {
    const res = await fetch(`${API}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    return res.json();
  }

  async getMe(token) {
    const res = await fetch(`${API}/auth/me`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return res.json();
  }
}

export default new AuthService();
